export const TYPE_CHAIN = 'CHAIN', TYPE_HOTEL = 'HOTEL', ID_OF_NEW = 'NEW';
